import React, { useState, useEffect } from "react";
import img1 from "../Assests/images/sec2_1img.png";
import img2 from "../Assests/images/sec2_2img.png";
import img3 from "../Assests/images/sec2_3img.png";

const features = [
  {
    image: img1,
    title: "Ayurveda Clinics & Hospitals",
    subtitle: "Make Patients Waiting Time Worthwhile?",
    description:
      "Experience a Smarter, Time-Saving Solution with Our AI Kiosk!",
  },
  {
    image: img2,
    title: "Ayurveda Shops",
    subtitle: "Get Personalized Herbal Recommendations Instantly",
    description:
      "Seamless, interactive Ayurveda products showcase - at your fingertips!",
  },
  {
    image: img3,
    title: "Ayurveda Centers",
    subtitle: "Smarter Ayur Wellness Centers",
    description:
      "Effortless health assessments, personalized Ayurveda insights, & smart product showcases.",
  },
  
];

const Fourth = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % features.length);
    }, 9000);
    return () => clearInterval(intervalId);
  }, []);

  const currentFeature = features[currentIndex];

  return (
    <div className="feature-background-secound">
      

      

      <div className="feature-container active">
        
        <div className="feature-box content-box">
          <div className="feature-box-header">
            <div>
              <p className="feature-button">AI Kiosk Application</p>
            </div>
            <div className="feature-box-content">
              <p className="feature-content">{currentFeature.title}</p>
              <p className="feature-content-1">{currentFeature.subtitle}</p>
              <p className="feature-content-2">{currentFeature.description}</p>
              <div className="flex items-center gap-3 mt-4 feature-content-3">
                {features.map((_, index) => (
                  <div
                    key={index}
                    className={
                      currentIndex === index
                        ? "w-[86px] h-1.5 bg-[#1d8588] rounded-lg"
                        : "w-1.5 h-1.5 bg-[#d9d9d9] rounded-lg"
                    }
                  />
                ))}
              </div>
            </div>   
          </div>
          
        </div>
        <div className="feature-box ">
          <img
            src={currentFeature.image}
            alt={`Feature ${currentIndex + 1}`}
            className="image-box-new"
          />
        </div>
      </div>

    </div>
  );
};

export default Fourth;
